var React = require('react');

function ProgressOuter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.94754 13.6L2.47082 8L5.94754 2.4H100.053L103.529 8L100.053 13.6H5.94754Z","stroke":"#3B4049","strokeWidth":"0.8","key":0}),React.createElement("path",{"d":"M5.72506 1.45H5.41915L5.25779 1.7099L1.53273 7.7099L1.35262 8L1.53273 8.2901L5.25779 14.2901L5.41915 14.55H5.72506H100.275H100.581L100.742 14.2901L104.467 8.29009L104.647 8L104.467 7.70991L100.742 1.70991L100.581 1.45H100.275H5.72506Z","stroke":"white","strokeWidth":"1.1","key":1})]);
}

ProgressOuter.defaultProps = {"width":"106","height":"16","viewBox":"0 0 106 16","fill":"none"};

module.exports = ProgressOuter;

ProgressOuter.default = ProgressOuter;
